import { Component, Inject, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { BehaviorSubject, Observable, ReplaySubject } from 'rxjs';
import { finalize, takeUntil } from 'rxjs/operators';
import { FormControl, Validators } from '@angular/forms';
import { HttpResponse } from '@angular/common/http';

import { DateLessThanOrEqualsValidator } from '../../../rnpl-common/validators/date-less-than-or-equals.validator';

type SubmitRequestFunction = (executionDate: Date) => Observable<HttpResponse<Blob>>;

@Component({
  selector: 'rnpl-sepa-execution-date-modal',
  templateUrl: './sepa-execution-date-modal.component.html',
})
export class SepaExecutionDateModalComponent implements OnDestroy {
  public today = new Date(new Date().setHours(0, 0, 0));
  public executionDate: FormControl = new FormControl(new Date(), [Validators.required, DateLessThanOrEqualsValidator(this.today)]);

  readonly submitRequest$: BehaviorSubject<boolean> = new BehaviorSubject(null);
  readonly destroy$: ReplaySubject<void> = new ReplaySubject(1);

  constructor(
    public dialogRef: MatDialogRef<SepaExecutionDateModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      submitRequestFn$: SubmitRequestFunction;
    }
  ) {
    this.dialogRef.keydownEvents().subscribe(event => {
      if (event.key === 'Escape') {
        this.dialogRef.close();
      }
    });
  }

  public submit(): void {
    this.executionDate.markAsTouched();
    this.executionDate.updateValueAndValidity();

    if (this.executionDate.invalid) { return; }
    if (this.submitRequest$.getValue()) { return; }
    this.submitRequest$.next(true);

    this.data.submitRequestFn$(this.executionDate.value)
      .pipe(
        finalize(() => this.submitRequest$.next(false)),
        takeUntil(this.destroy$)
      )
      .subscribe(() => this.dialogRef.close());
  }

  ngOnDestroy(): void {
    this.destroy$.next(null);
    this.destroy$.complete();
  }
}
